<script>
import { authComputed } from "@/state/helpers";
import moment from "moment";
import BookingService from "@/helpers/APIService/booking.service";
export default {
  data() {
    return {
      showBookingDetail: false,
      profileLoader: false,
      upsellData: null,
      bookingDetail: null,
    };
  },
  computed: {
    ...authComputed,
  },
  props: {
    userData: Object,
  },
  mounted() {
    this.$root.$on("showDetail", (data) => {
      this.showBookingDetail = data;
    });
  },
  methods: {
    async showGuestInfo() {
      this.showBookingDetail = !this.showBookingDetail;
      this.$root.$emit("showBookingDetail", this.showBookingDetail);
      this.profileLoader = true;
      if (this.showBookingDetail == true) {
        if (this.userData != null && this.userData.group_send_number != null) {
          let response = await BookingService.getBookingList(
            `?or_primary_guest__mobile=${this.userData.group_send_number}`
          );
          if (response.results.length !== 0) {
            this.bookingDetail = response.results[0];
            this.upsellData = await BookingService.getUpsellOrder(
              this.bookingDetail.id
            );
          } else {
            this.bookingDetail = null;
            this.upsellData = null;
          }
        }
        if (
          this.userData.inbox_user != undefined &&
          this.userData.inbox_user != null &&
          this.userData.inbox_user.mobile != null
        ) {
          const response = await BookingService.getBookingList(
            `?or_primary_guest__mobile=${this.userData.inbox_user.mobile}`
          );
          if (response.results.length !== 0) {
            this.bookingDetail = response.results[0];
          } else {
            this.bookingDetail = null;
            this.upsellData = null;
          }
        }
      } else {
        this.bookingDetail = null;
        this.upsellData = null;
      }
      this.profileLoader = false;
    },
    convertDateOrTime(dateTime, format) {
      if (format !== "fromNow") return moment(dateTime).format(format);
      else return moment(dateTime).fromNow();
    },
  },
};
</script>

<template>
  <div
    v-if="!userData.personal && userData.group_type != 'common_lobby'"
    class="d-md-block d-none"
    :class="showBookingDetail ? 'w-20' : 'w-5'"
  >
    <div :class="showBookingDetail ? 'p-3 pe-0' : 'py-3'">
      <div class="d-flex align-items-center justify-content-between">
        <h5 v-if="showBookingDetail">Guest Information</h5>
        <div class="picture-img ms-auto cursor">
          <span
            class="avatar-title rounded-circle bg-secondary bg-soft"
            @click="showGuestInfo"
            ><i class="fas fa-user text-secondary"></i
          ></span>
        </div>
      </div>
    </div>
    <div class="ps-3" v-if="showBookingDetail">
      <div v-if="profileLoader">
        <div class="placeholder-glow my-3">
          <div
            class="placeholder w-100 placeholder-lg avatar-placeholder rounded-circle d-block mx-auto"
          ></div>
          <span
            class="placeholder w-50 placeholder-lg checkbox-wrapper-mail px-3 d-block mx-auto"
            style="height: 17px"
          ></span>
          <span
            class="placeholder w-80 placeholder-lg checkbox-wrapper-mail px-3 d-block mx-auto"
            style="height: 17px"
          ></span>
        </div>
        <div>
          <div v-for="num in 2" :key="num">
            <hr class="my-0" />
            <li class="placeholder-glow d-flex align-items-center py-1 px-3">
              <span
                class="placeholder w-100 placeholder-lg checkbox-wrapper-mail"
                style="height: 35px"
              ></span>
            </li>
            <hr class="my-0" />
            <div v-for="item in 3" :key="item">
              <li class="placeholder-glow d-flex align-items-center py-1 px-3">
                <span
                  class="placeholder w-100 placeholder checkbox-wrapper-mail"
                  style="height: 27px"
                ></span>
              </li>
            </div>
          </div>
        </div>
        <hr class="my-0" />
        <li class="placeholder-glow d-flex align-items-center py-1 px-3">
          <span
            class="placeholder w-100 placeholder-lg checkbox-wrapper-mail"
            style="height: 35px"
          ></span>
        </li>
        <hr class="my-0" />
      </div>
      <div class="booking-information" v-else>
        <div class="text-center">
          <div
            v-if="
              (userData.group_type == 'common_lobby' &&
                user.user.message_app_setting.is_edit_lobby_inbox_group) ||
              (userData.group_type == 'guest' &&
                user.user.message_app_setting.is_edit_guest_inbox_group)
            "
          >
            <!-- @click="updateProfile" -->
            <img
              class="avatar-lg mx-auto my-3 rounded-circle cursor"
              v-if="
                bookingDetail != null &&
                bookingDetail.primary_guest &&
                bookingDetail.primary_guest.selfie_image != null
              "
              :src="bookingDetail.primary_guest.selfie_image"
            />
            <!-- @click="updateProfile" -->
            <img
              class="avatar-lg mx-auto my-3 rounded-circle cursor"
              v-else-if="userData.group_avtar"
              :src="userData.group_avtar"
            />
            <img
              v-else-if="
                userData.inbox_user && userData.inbox_user.profile_picture
              "
              :src="userData.inbox_user.profile_picture"
              class="avatar-lg mx-auto rounded-circle cursor"
              alt="profile-photo"
            />
            <!-- @click="updateProfile" -->
            <img
              class="avatar-lg mx-auto my-3 rounded-circle cursor"
              v-else-if="userData.profile_picture"
              :src="userData.profile_picture"
            />
            <!-- @click="updateProfile" -->
            <div class="avatar-lg mx-auto my-3 rounded-circle cursor" v-else>
              <span
                class="avatar-title rounded-circle bg-soft bg-primary text-primary text-capitalize fs-3"
                v-if="
                  bookingDetail != null &&
                  bookingDetail.primary_guest &&
                  bookingDetail.primary_guest.first_name &&
                  bookingDetail.primary_guest.last_name
                "
              >
                {{
                  bookingDetail.primary_guest.first_name.charAt(0) +
                  bookingDetail.primary_guest.last_name.charAt(0)
                }}
              </span>
              <span
                class="avatar-title rounded-circle bg-soft bg-primary text-primary text-capitalize fs-3"
                v-else
              >
                {{ userData.name ? userData.name.charAt(0) : "c" }}
              </span>
            </div>
          </div>
          <p
            class="mb-2 col-md-12"
            v-if="
              bookingDetail != null &&
              bookingDetail.primary_guest &&
              bookingDetail.primary_guest.first_name &&
              bookingDetail.primary_guest.last_name
            "
          >
            {{
              bookingDetail.primary_guest.first_name +
              " " +
              bookingDetail.primary_guest.last_name
            }}
          </p>
          <p class="mb-2 col-md-12" v-else>
            {{ userData.group_send_number }}
          </p>
          <h5>Booking Information</h5>
          <hr />
        </div>
        <div v-if="bookingDetail != null">
          <div class="d-flex my-2">
            <h5 class="font-size-14 mb-0 col-md-3">Check In</h5>
            <span class="mx-2">:</span>
            <span>
              {{
                bookingDetail.check_in_date
                  ? convertDateOrTime(
                      bookingDetail.check_in_date,
                      "DD MMM YYYY"
                    ) + " - "
                  : "Not Available"
              }}
              {{
                bookingDetail.check_in_time ? bookingDetail.check_in_time : ""
              }}</span
            >
          </div>
          <div class="d-flex my-2">
            <h5 class="font-size-14 mb-0 col-md-3">Check Out</h5>
            <span class="mx-2">:</span>
            <span
              >{{
                bookingDetail.check_out_date
                  ? convertDateOrTime(
                      bookingDetail.check_out_date,
                      "DD MMM YYYY"
                    ) + " - "
                  : "Not Available"
              }}
              {{
                bookingDetail.check_out_time ? bookingDetail.check_out_time : ""
              }}</span
            >
          </div>
          <div class="d-flex my-2">
            <h5 class="font-size-14 mb-0 col-md-3">Room Number</h5>
            <span class="mx-2">:</span>
            <span>{{
              bookingDetail.allotted_room != null
                ? bookingDetail.allotted_room.room_number
                : "Not Allocated"
            }}</span>
          </div>
          <div class="d-flex my-2">
            <h5 class="font-size-14 mb-0 col-md-3">Status</h5>
            <span class="mx-2">:</span>
            <span>{{
              bookingDetail.status != null
                ? bookingDetail.status === "new_booking" ||
                  bookingDetail.status == "pre_checkin"
                  ? "New Booking"
                  : bookingDetail.status === "reservation"
                  ? "Reservation"
                  : bookingDetail.status === "pre_checked_done"
                  ? "Pre Checked-In"
                  : bookingDetail.status === "checked_in"
                  ? "Checked In"
                  : bookingDetail.status === "checked_out"
                  ? "Checked Out"
                  : bookingDetail.status === "cancelled"
                  ? "Cancelled"
                  : "No Show"
                : "Not Available"
            }}</span>
          </div>
        </div>
        <div class="d-flex my-2" v-else>
          <span class="text-center">No Booking Found</span>
        </div>
        <hr />
        <h5 class="text-center">
          Service Request
          <span v-if="upsellData != null">{{
            "(" + upsellData.length + ")"
          }}</span>
        </h5>
        <hr />
        <div
          v-if="
            upsellData != null || (upsellData != null && upsellData.length != 0)
          "
        >
          <div v-for="upsell in upsellData" :key="upsell.id">
            <div class="d-flex my-2">
              <h5 class="font-size-15 mb-0 col-md-5">
                {{ upsell.upsell.title }}
              </h5>
              <span class="mx-2">:</span>
              <span>{{ upsell.approve_status }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="text-center">No Service Requests</span>
        </div>
        <hr />
        <h5 class="text-center">Maintenance Issue (0)</h5>
        <hr />
      </div>
    </div>
  </div>
</template>
